import { getQueryVariable, parseVideoSrc } from '@/utils/common'
import { getRedirectUrl } from '@/utils/api'

export function setupOpenwith(cordova, vueApp) {
    // Increase verbosity if you need more logs
    // cordova.openwith.setVerbosity(cordova.openwith.DEBUG)

    // Initialize the plugin
    cordova.openwith.init(initSuccess, initError)

    function initSuccess() { console.log('init success!') }
    function initError(err) { console.log('init failed: ' + err) }

    // Define your file handler
    cordova.openwith.addHandler(shareHandler)

    async function shareHandler(intent) {
        let videoURL = false
        let tokenUrl = false
        let videoSrc
        for (let i = 0; i < intent.items.length; ++i) {
            let item = intent.items[i]
            if (!item.text) continue
            videoSrc = parseVideoSrc(item.text)
            if (videoSrc === 'youtube') {
                videoURL = item.text
            } else if (videoSrc === 'bilibili') {
                let startIndex = item.text.indexOf('http')
                let url = item.text.substring(startIndex)
                let redirectUrl = await getRedirectUrl(url)
                if (redirectUrl.request && redirectUrl.request.responseURL) {
                    videoURL = redirectUrl.request.responseURL
                } else {
                    videoURL = false
                }
            } else if (item.text.indexOf('token=')) {
                tokenUrl = true
            } else {
                videoURL = false
            }
        }

        if (videoURL) {
            vueApp.$store.commit('SET_SHARING_VIDEO_URL', videoURL)
        } else {
            if (!tokenUrl) {
                alert(vueApp.$t('video.notSupportVideoType'))
            } else {
                localStorage.setItem('user_token', getQueryVariable(tokenUrl, 'token'))
                localStorage.setItem('user_token_ts', new Date().getTime())
                return
            }
        }

        if (intent.exit) {
            cordova.openwith.exit()
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/openwith.js